// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1KeHf","header":"ReportDetails_header__2c0Tj","title":"ReportDetails_title__3PYdQ","left":"ReportDetails_left__3xOY7"};